module.exports = __webpack_public_path__ + "static/media/me.92572641.jpg";